import { FavoritesAddModal } from "./FavoritesAddModal";

export default FavoritesAddModal;
